<script lang="ts">
  import { Icon } from '@shared/ui/icon';
  import { PURCHASE_TIP_TEXTS } from '@shared/ui/purchase-tip/configs';
  import { StepSwitch } from '@shared/ui/step-switch';
  import { theme, ThemeModes } from '@shared/ui/theme';
  import { is, isSafari } from '@shared/utils';

  export let state: 'approval' | 'pending' = 'pending';
  export let purchaseType: 'auction' | 'purchase';

  $: isFirstStep = state === 'approval';
  $: info = PURCHASE_TIP_TEXTS[purchaseType][state];
  $: isSafariBrowser = isSafari();
</script>

<section>
  <StepSwitch {isFirstStep} firstStepClasses="rounded-bl-none" secondStepClasses="rounded-br-none" />

  <div class="border-default-250 dark:border-dark-400 rounded-lg rounded-t-none border border-t-0 p-5">
    <p class="dark:text-dark-800 text-default-800 mb-5">
      {info.description}
    </p>

    <article>
      <div class="flex items-center gap-4">
        <div class="text-default-320 dark:text-dark-200 shrink-0">
          <Icon
            name="{isSafariBrowser ? 'phone-auth' : 'desktop-auth'}"
            variant="{is($theme === ThemeModes.Dark, 'dark', 'default')}"
          />
        </div>

        <p class="dark:text-dark-800 text-default-800 text-base">
          <!-- eslint-disable-next-line -->
          {@html isSafariBrowser ? info.mobile : info.desktop}
        </p>
      </div>
    </article>
  </div>
</section>
